import { NonQualifyingAdverb } from '../../types'

const нах: NonQualifyingAdverb = {
  type: 'non qualifying adverb',
  adverb: 'нах',
}

export default нах
